import React, { useState } from 'react';
import { motion } from 'framer-motion';
import RequestQuoteModal from '../components/RequestQuoteModal';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const products = [
  {
    id: 1,
    category: 'medical-gas',
    name: 'Theatre Suction Unit',
    image:"/images/products/theater-suction-trolly.jpg",
    description: 'A theater suction trolley is a mobile medical suction unit designed for use in surgical theaters and other clinical settings. Its primary function is to remove bodily fluids, blood, and gases from patients during and after surgical procedures.',
    features: [
      "Vacuum Pump: Generates the negative pressure required for suction. It may be electrically powered or manually operated.",
"Collection Canisters: Often multiple jars (including a safety jar) to collect aspirated fluids while preventing contamination or overflow.",
],
  },
  {
    id: 2,
    category: 'medical-gas',
    name: 'Bed Head Panel',
    image: '/images/products/bed-head-panel.jpg',
    description: 'A theater suction trolley is a mobile medical suction unit designed for use in surgical theaters and other clinical settings. Its primary function is to remove bodily fluids, blood, and gases from patients during and after surgical procedures. This device ensures a clear surgical field and supports effective patient care.',
    features: [
      'Multiple gas outlets',
      'Electrical sockets',
      'LED lighting',
      'Nurse call system integration',
    ],
  },
  {
    id: 3,
    category: 'medical-gas',
    name: 'Air Compressor',
    image: '/images/products/air-compressor.jpg',
    description: 'Medical air compressors are essential devices in hospitals and clinics, supplying clean, compressed air for various critical applications. They are used in respiratory therapy to assist patients with breathing, in anesthesia machines to deliver gases, and to power surgical instruments.',
    features: [
      'High efficiency',
      'Low noise operation',
      'Continuous duty rated',
    ],
  },
  {
    id: 4,
    category: 'medical-gas',
    name: 'Automatic Gas Control Panel/Reductions Station',
    image: '/images/products/automatic-gas-control-panel.jpg',
    description: 'The Automatic Gas Control Panel is a critical component in centralized medical gas pipeline systems, enabling safe and continuous delivery of gases like oxygen, nitrous oxide,CO2.',
    features: [
      'Automatic switching',
      'Pressure monitoring',
      'User-friendly interface',
    ],
  },
  {
    id: 7,
    category: 'medical-gas',
    name: 'Medical Vacuum System',
    image: '/images/products/medical-vacuum-system.jpg',
    description: 'Medical vacuum systems are critical in hospital settings, primarily used for suction during surgeries, airway clearance, and wound drainage. These systems must be reliable, safe, and compliant with international healthcare standards.',
    features: [
      'High efficiency',
      'Low noise operation',
      'Continuous duty rated',
    ],
  },
  {
    id: 10,
    category: 'medical-gas',
    name: 'Ward Vacuum Units',
    image: '/images/products/ward-vacuum-units.png',
    description: 'A Ward Vacuum in a hospital setting refers to a central suction system installed in patient care areas (wards). It’s used for medical procedures such as removing fluids, blood, or mucus from a patient’s airway or surgical site.',
    features: [
      'Easy to operate',
      'Compact design',
      'Reliable suction',
    ],
  },
  {
    id: 11,
    category: 'medical-gas',
    name: 'Gas Manifold System, Pig Tail & NRVs for manifold',
    image: '/images/products/gas-manifold-system.jpg',
    description: 'A gas manifold system in a hospital is a centralized system used to supply medical gases—such as oxygen, nitrous oxide, and medical air—from large storage cylinders or liquid sources to different areas of the facility.',
    features: [
      'Durable construction',
      'Leak-proof connections',
      'Easy installation',
    ],
  },
  {
    id: 13,
    category: 'medical-gas',
    name: 'Anti-Static High Pressure Tube',
    image: '/images/products/anti-static-high-pressure.jpg',
    description: 'An Anti-Static High Pressure Tube is a specialized medical-grade tubing designed to transport gases under high pressure, such as oxygen or nitrous oxide, safely within hospital settings.',
    features: [
      'High flexibility',
      'Pressure resistant',
      'Color coded',
    ],
  },
  {
    id: 14,
    category: 'medical-gas',
    name: 'Master Alarm',
    image: '/images/products/master-alarm.jpg',
    description: 'A Master Alarm System is a centralized monitoring panel used in hospitals to oversee the status of medical gas pipeline systems, including oxygen, nitrous oxide, medical air, vacuum, and carbon dioxide.',
    features: [
      'Monitoring hospital-wide medical gas systems',
      'Detecting pressure loss, gas leaks, or equipment failure',
      'Alerting staff to low gas cylinder levels or system malfunctions',
    ],
  },
  {
    id: 15,
    category: 'medical-gas',
    name: 'Gas Outlet/Terminal Unit',
    image: '/images/products/gas-outlet.jpg',
    description: 'A Gas Outlet or Terminal Unit is a critical component of the medical gas pipeline system in hospitals. It is the point where medical staff connect equipment—such as ventilators, anesthesia machines, or oxygen masks—to access gases like oxygen, medical air, nitrous oxide, or vacuum.',
    features: [
      'Secure connections',
      'Multiple gas types',
      'Easy maintenance',
    ],
  },
  {
    id: 16,
    category: 'medical-gas',
    name: 'Ceiling Pendant',
    image: '/images/products/ceiling-pendant.jpg',
    description: 'A Ceiling Pendant in hospitals is a ceiling-mounted system designed to manage medical equipment, gases, electrical supply, and data services in critical care areas like ICUs, operating rooms, and emergency departments.',
    features: [
      'Flexible positioning',
      'Integrated gas outlets',
      'Space-saving design',
    ],
  },
  {
    id: 17,
    category: 'medical-gas',
    name: 'AVSU(with Integrated Alarm Panel)',
    image: '/images/products/avsu.jpg',
    description: 'An AVSU (Area Valve Service Unit), commonly known as a Zonal Valve Box, is a critical safety component of the medical gas pipeline system in hospitals. It is installed in each zone or department (such as ICU, OT, wards) to control and isolate the flow of medical gases—like oxygen, nitrous oxide, medical air, and vacuum—to specific areas.',
    features: [
      'Integrated alarm system',
      'Easy access valves',
      'Enhanced safety',
    ],
  },
  {
    id: 18,
    category: 'medical-gas',
    name: 'Oxygen flow mater, BPC, Flow meter, Suction Unit',
    image: '/images/products/oxygen-flow-mater.jpg',
    description: 'An Oxygen Flow Meter, often referred to as a BPC Flowmeter (British Pattern Connector), is a medical device used to regulate and measure the flow rate of oxygen from a supply source to the patient.',
    features: [
      'Accurate flow measurement',
      'Integrated suction',
      'User-friendly controls',
    ],
  },
  {
    id: 19,
    category: 'medical-gas',
    name: 'Isolation Valve',
    image: '/images/products/isolation-valve.jpg',
    description: "An Isolation Valve is a vital component of a hospital's medical gas pipeline system, used to manually stop or isolate the flow of gases like oxygen, nitrous oxide, or vacuum in a specific section of the building.",
    features: [
      'Reliable shut-off',
      'Easy operation',
      'Durable construction',
    ],
  },
  {
    id: 20,
    category: 'medical-gas',
    name: 'Pressure Regulators',
    image: '/images/products/pressure-regulators.jpg',
    description: 'A Pressure Regulator is an essential component in hospital medical gas systems, designed to reduce and maintain high-pressure gas—such as oxygen, nitrous oxide, or medical air—at a safe and consistent working pressure for clinical use.',
    features: [
      'Accurate pressure control',
      'Robust build',
      'Easy adjustment',
    ],
  },
  {
    id: 21,
    category: 'medical-gas',
    name: 'Copper Pipe',
    image: '/images/products/copper-pipe.jpeg',
    description: 'Copper pipes are the standard piping material used in hospital medical gas pipeline systems (MGPS). They transport critical gases such as oxygen, nitrous oxide, medical air, vacuum, and carbon dioxide from central supply systems (like manifolds or liquid tanks) to various patient care areas.',
    features: [
      'Corrosion resistant',
      'HTM 02-01 compliant',
      'Multiple sizes',
    ],
  },
  {
    id: 22,
    category: 'medical-gas',
    name: 'Area Alarm Panel',
    image: '/images/products/area-alerm-panel.jpg',
    description: 'An Area Alarm Panel is a monitoring device used in hospitals to supervise the status of medical gas systems within a specific zone or department, such as an ICU, operating room, or ward.',
    features: [
      'Programmable logic control',
      'User-friendly interface',
      'Reliable automation',
    ],
  },
  {
    id: 23,
    category: 'medical-gas',
    name: 'Anaesthesia Gas Scavenging System',
    image: '/images/products/anaesthesia-gas-scavenging-system.png',
    description: "The Anaesthesia Gas Scavenging System (AGSS) is a vital safety mechanism in operating rooms designed to collect and safely remove waste anaesthetic gases (such as nitrous oxide and halogenated agents) that escape from a patient's breathing system.",
    features: [
      'Efficient gas removal',
      'Safety compliant',
      'Low maintenance',
    ],
  },
  {
    id: 24,
    category: 'medical-gas',
    name: 'LMO Tank/PSA Plant',
    image: '/images/products/lmo-tank.jpg',
    description: 'In hospitals, LMO Tanks (Liquid Medical Oxygen tanks) and PSA Plants (Pressure Swing Adsorption plants) are key systems used to supply medical-grade oxygen to patients.',
    features: [
      'Large capacity',
      'Insulated design',
      'Safe storage',
    ],
  },
  {
    id: 0,
    category: 'medical-gas',
    name: 'MGPS Other Equipment Details',
    image: '',
    description: 'Liquid Medical Oxygen (LMO) tank for bulk oxygen storage.',
    features: [
      'Large capacity',
      'Insulated design',
      'Safe storage',
    ],
  },
  {
    id: 25,
    category: 'modular-operation-theatre',
    name: 'Prefabricated Walls & Ceiling Panel-SS/SMS/GI/EGP',
    image: '/images/products/prefabricated-walls.jpg',
    description: 'Prefabricated walls and ceiling panels are modular construction components used in modern hospitals, particularly in critical areas like Operating Theatres (OTs), ICUs, labs, and clean rooms.',
    features: [
      'Corrosion resistant',
      'Easy to clean',
      'Long-lasting finish',
    ],
  },
  {
    id: 26,
    category: 'modular-operation-theatre',
    name: 'Anti-bacterial/Anti-fungal Paint',
    image: '/images/products/anti-bacterial.jpg',
    description: 'Anti-bacterial and anti-fungal paint is a specialized coating used in hospitals and healthcare facilities to inhibit the growth of harmful microorganisms such as bacteria, mold, and fungi on walls and ceilings.',
    features: [
      'Prevents microbial growth',
      'Smooth finish',
      'Easy application',
    ],
  },
  {
    id: 27,
    category: 'modular-operation-theatre',
    name: 'Laminar Air Flow System',
    image: '/images/products/laminar-air-flow-system.jpg',
    description: 'A Laminar Air Flow (LAF) System is a specialized air purification system used in critical hospital environments such as Operating Theatres (OTs), ICUs, cleanrooms, and labs.',
    features: [
      'Waterproof',
      'Slip-resistant',
      'Low maintenance',
    ],
  },
  {
    id: 28,
    category: 'modular-operation-theatre',
    name: 'Conductive Seamless Flooring with Coving on all Corners',
    image: '/images/products/conductive-seamless-flooring.jpg',
    description: 'Conductive seamless flooring with coving is a high-performance flooring solution used in critical hospital areas like Operation Theatres (OTs), ICUs, labs, and pharmaceutical cleanrooms.',
    features: [
      'Uniform air distribution',
      'Reduces contamination',
      'Energy efficient',
    ],
  },
  {
    id: 29,
    category: 'modular-operation-theatre',
    name: 'Hermetically Sealed Sliding Door System',
    image: '/images/products/hermetically-sealed-sliding-door-system.jpg',
    description: 'A Hermetically Sealed Sliding Door System is a specialized hospital door designed to provide an airtight seal when closed, minimizing air leakage and controlling the movement of airborne contaminants.',
    features: [
      'Energy saving',
      'Dust proof',
      'Long lifespan',
    ],
  },
  {
    id: 30,
    category: 'modular-operation-theatre',
    name: 'Surgeon Control Panel',
    image: '/images/products/surgeon-control-panel.jpg',
    description: 'A Surgeon Control Panel is an integrated wall-mounted interface used in Operation Theatres (OTs) to centralize and control essential room functions, providing surgeons and staff with quick, sterile, and efficient access to critical controls.',
    features: [
      'Touchless operation',
      'Smooth sliding',
      'Safety sensors',
    ],
  },
  {
    id: 31,
    category: 'modular-operation-theatre',
    name: 'X-Ray View Screen',
    image: '/images/products/x-ray-view-screen.jpg',
    description: 'An X-Ray View Screen (also known as a Film Illuminator or X-ray Viewer) is a wall-mounted or portable device used in hospitals to illuminate and view radiographic films, such as X-rays, CT scans, and MRIs.',
    features: [
      'Used by surgeons during operations for reference',
      'Assists radiologists and clinicians in interpreting medical images',
      'Essential in trauma, orthopedic, and dental units',
    ],
  },
  {
    id: 32,
    category: 'modular-operation-theatre',
    name: 'Writing White Board',
    image: '/images/products/writing-white-board.jpg',
    description: 'A Writing White Board in hospitals is a smooth, erasable surface used for writing, planning, and communication within clinical environments.',
    features: [
      'Recording surgery schedules and checklists in OTs',
      'Communication among medical teams during rounds',
      'Educational tool in training rooms and discussions',
    ],
  }, 
  {
    id: 33,
    category: 'modular-operation-theatre',
    name: 'Pressure Release Damper',
    image: '/images/products/pressure-release-damper.jpg',
    description: 'A Pressure Release Damper (PRD) is a safety device installed in hospital ventilation systems, particularly in modular operation theatres, cleanrooms, ICUs, isolation rooms, and labs.',
    features: [
      'Preventing structural damage from air pressure buildup',
      'Balancing airflow between sterile and non-sterile zones',
      'Enhancing HVAC efficiency by regulating pressure',
    ],
  }, 
  {
    id: 34,
    category: 'modular-operation-theatre',
    name: 'Peripheral Lights (Dimmable)',
    image: '/images/products/peripheral-lights.jpg',
    description: 'Peripheral Lights (Dimmable) are ambient lighting fixtures installed around the perimeter of Operation Theatres (OTs) and other critical hospital areas.',
    features: [
      'Centralized controls',
      'Easy monitoring',
      'Robust design',
    ],
  }, 
  {
    id: 35,
    category: 'modular-operation-theatre',
    name: 'Surgeon Pendant',
    image: '/images/products/surgeon-pendant.png',
    description: 'A Surgeon Pendant is a ceiling-mounted, movable equipment management system used in Operation Theatres (OTs) to provide surgeons with organized and immediate access to essential utilities.',
    features: [
      'Delivering medical gases and electrical power to the surgical field',
      'Supporting surgical equipment, monitors, and electrosurgical units',
      'Reducing floor clutter for better mobility and hygiene',
    ],
  }, 
  {
    id: 36,
    category: 'modular-operation-theatre',
    name: 'Anaesthesia Pendant',
    image: '/images/products/anaesthesia-pendant.jpg',
    description: 'An Anaesthesia Pendant is a ceiling-mounted medical equipment management system specifically designed for delivering anesthesia safely and efficiently in Operation Theatres (OTs).',
    features: [
      'Supplying medical gases to anesthesia workstations',
      'Powering and supporting anesthesia machines and monitors',
      'Organizing suction devices, ventilators, and infusion pumps',
    ],
  },
  {
    id: 37,
    category: 'modular-operation-theatre',
    name: 'Scrub Station',
    image: '/images/products/scrub-station.jpg',
    description: 'A Scrub Station is a specially designed handwashing and scrubbing unit installed outside Operation Theatres (OTs) and sterile zones in hospitals.',
    features: [
      'Pre-operative hand scrubbing for surgical teams',
      'Maintaining sterility before entering OTs or cleanrooms',
      'Reducing infection risks by ensuring hygienic practices',
    ],
  }, 
  {
    id: 38,
    category: 'modular-operation-theatre',
    name: 'Extension Arm for Endoscopy',
    image: '/images/products/extension-arm-for-endoscopy.jpg',
    description: 'An Extension Arm for Endoscopy is a ceiling- or wall-mounted articulating support arm used to hold and position endoscopy equipment such as cameras, monitors, light sources, and scopes in Operating Theatres (OTs), gastroenterology suites, and procedure rooms.',
    features: [
      'Holding endoscopy cameras and monitors during procedures',
      'Providing stable positioning for video and imaging equipment',
      'Freeing up floor space and improving room organization',
    ],
  }, 
  {
    id: 39,
    category: 'modular-operation-theatre',
    name: 'Electrical DB',
    image: '/images/products/electrical-db.jpg',
    description: 'An Electrical Distribution Board (DB) is a central panel that distributes electrical power from the hospital’s main supply to various circuits throughout the facility.',
    features: [
      'Ensuring power supply continuity for life-saving equipment',
      'Separating normal and emergency power through dual feeds',
      'Managing power safely in high-dependency and technical zones',
    ],
  },
  {
    id: 40,
    category: 'modular-operation-theatre',
    name: 'View Window',
    image: '/images/products/view-window.jpg',
    description: 'A View Window in hospitals is a transparent, fixed-glass panel installed in walls or doors to allow visual monitoring between rooms—especially in Operation Theatres (OTs), ICUs, isolation wards, and cleanrooms—without physical entry.',
    features: [
      'Monitoring patients or procedures from outside sterile or critical zones',
      'Facilitating communication between staff in adjacent rooms',
      'Allowing observation in OTs, ICUs, labs, and neonatal units',
    ],
  },   
  {
    id: 41,
    category: 'modular-operation-theatre',
    name: 'Storage Units',
    image: '/images/products/storage-units.jpg',
    description: 'Storage Units in hospitals are specially designed cabinets, racks, and shelves used to organize and safely store medical supplies, equipment, medications, instruments, and PPE.',
    features: [
      'Housing diagnostic tools in labs and procedure areas',
      'Keeping patient-care supplies accessible in wards and ICUs',
      'Managing PPE and emergency kits in isolation or critical zones',
    ],
  },
  {
    id: 42,
    category: 'modular-operation-theatre',
    name: 'OT Light',
    image: '/images/products/ot-light.jpg',
    description: 'An OT Light, also known as a surgical or operating light, is a specialized lighting fixture used in Operation Theatres to provide bright, focused, shadow-free illumination during surgical procedures.',
    features: [
      'Illuminating the surgical site with high clarity',
      'Enhancing visibility for precise incisions and sutures',
      'Used in major and minor surgeries across all specialties',
    ],
  }, 
  {
    id: 43,
    category: 'modular-operation-theatre',
    name: 'Medical Isolation Panel',
    image: '/images/products/medical-isolation-panel.jpg',
    description: 'A Medical Isolation Panel is an essential electrical safety device installed in Operation Theatres (OTs), ICUs, and other critical care areas.',
    features: [
      'Monitoring insulation resistance and grounding faults',
      'Ensuring continuous power during electrical disturbances',
      'Protecting sensitive equipment from power surges or failures',
    ],
  },
  {
    id: 44,
    category: 'modular-operation-theatre',
    name: 'OT integration',
    image: '/images/products/ot-integration.jpg',
    description: 'OT Integration refers to the centralized digital management of all equipment, data, video, and environmental controls within an Operation Theatre (OT) through a unified interface.',
    features: [
      'Centralized control of surgical equipment, lights, and imaging systems',
      'Real-time access to patient data, imaging, and lab reports',
      'Live transmission of surgeries for teaching or teleconsultation',
    ],
  }, 
  {
    id: 45,
    category: 'penumatic-tube-system',
    name: 'Writing White Board',
    description: 'System for safe removal of waste anaesthetic gases.',
    features: [
      'Communication among medical teams during rounds',
      'Educational tool in training rooms and discussions',
      'Task planning and shift changes in nurse stations',
    ],
  },
  {
    id: 46,
    category: 'nurse-call-system',
    name: 'Anaesthesia Gas Scavenging System',
    description: 'System for safe removal of waste anaesthetic gases.',
    features: [
      'Efficient gas removal',
      'Safety compliant',
      'Low maintenance',
    ],
  }
  // Add more products as needed
];

const Products = () => {
  const location = useLocation();
  const initialCategory = location.state?.selectedCategory || 'medical-gas';
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const [searchTerm, setSearchTerm] = useState('');
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  const filteredProducts = products.filter(product => {
    const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleRequestQuote = (product) => {
    setSelectedProduct(product);
    setIsQuoteModalOpen(true);
  };

  return (
    <div>
      <Helmet>
        <title>Hospital Equipment & Medical Gas Pipeline Products | Hospital Build</title>
        <meta name="description" content="Browse our range of hospital equipment, medical gas pipeline products, ICU equipment, OT lights, and hospital furniture. Quality products for healthcare facilities in India." />
        <meta name="keywords" content="Hospital Equipment, Medical Gas Pipeline Products, ICU Equipment, OT Lights, Hospital Furniture, Medical Equipment Supplier India" />
        <link rel="canonical" href="https://www.hospitalbuild.in/products" />
      </Helmet>
      <div className="container mx-auto px-4 py-8">      
      {/* <div className="flex gap-8 mb-16">          
          <div 
            className="relative w-1/2 h-[400px] rounded-lg"
            style={{
              backgroundImage: 'url("/images/blog/plant-room.svg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="absolute inset-0 bg-[#2C2C90]/80 rounded-lg"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
              <h1 className="text-6xl font-bold">Our Products</h1>
            </div>
          </div>          
          <div className="w-1/2 flex flex-col justify-center">
            <h2 className="text-4xl font-bold text-[#2C2C90] mb-6">
              Welcome to the Medical Gas Pipeline Blog
            </h2>
            <p className="text-gray-700 text-lg">
              Dedicated to professionals in the medical Gas pipeline manufacturing industry and our blog provides comprehensive insights into pipeline systems. We explore the best practices in manufacturing, cutting-edge technological advancements, and important regulatory updates. Stay informed and ahead with our expert analysis and industry news.
            </p>
          </div>
        </div> */}

      {/* Filters */}
      {/* <div className="container mx-auto px-4 py-8"> */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          {/* Category Filter */}
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setSelectedCategory('medical-gas')}
              className={`px-6 py-2 rounded-full transition-colors ${selectedCategory === 'medical-gas' ? 'bg-[#2C2C90] text-white' : 'bg-white text-[#2C2C90] border border-[#2C2C90] hover:bg-[#2C2C90] hover:text-white'}`}
            >
              Medical Gas Pipeline System
            </button>

            <button
              onClick={() => setSelectedCategory('modular-operation-theatre')}
              className={`px-6 py-2 rounded-full transition-colors ${selectedCategory === 'modular-operation-theatre' ? 'bg-[#2C2C90] text-white' : 'bg-white text-[#2C2C90] border border-[#2C2C90] hover:bg-[#2C2C90] hover:text-white'}`}
            >
              Modular Operation Theatre
            </button>

            <button
              onClick={() => setSelectedCategory('penumatic-tube-system')}
              className={`px-6 py-2 rounded-full transition-colors ${selectedCategory === 'penumatic-tube-system' ? 'bg-[#2C2C90] text-white' : 'bg-white text-[#2C2C90] border border-[#2C2C90] hover:bg-[#2C2C90] hover:text-white'}`}
            >
              Penumatic Tube System
            </button>
            
            <button
              onClick={() => setSelectedCategory('nurse-call-system')}
              className={`px-6 py-2 rounded-full transition-colors ${selectedCategory === 'nurse-call-system' ? 'bg-[#2C2C90] text-white' : 'bg-white text-[#2C2C90] border border-[#2C2C90] hover:bg-[#2C2C90] hover:text-white'}`}
            >
              Nurse Call System
            </button>
          </div>

          {/* Search */}
          <div className="relative">
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-64 pl-4 pr-10 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#2C2C90] focus:border-transparent"
            />
            <svg
              className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map(product => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow border border-gray-100 flex flex-col"
            >
              {/* object-cover */}
              <img 
                src={product?.image}
                alt={product.name}
                className="w-full h-64 content-fit bg-gray-50"
              />
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold mb-2 text-[#2C2C90]">{product.name}</h3>
                <p className="text-gray-600 mb-4">{product.description}</p>
                <ul className="space-y-2 mb-6 flex-grow">
                  {product.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm text-gray-600">
                      <svg className="w-5 h-5 text-[#2C2C90] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="flex gap-2 mt-auto">
                  <button 
                    onClick={() => navigate(`/products/${product.id}`, { state: { selectedCategory } })}
                    className="flex-1 bg-[#2C2C90] text-white py-2 rounded-full hover:bg-[#1A1A5C] transition-colors"
                  >
                    View Details
                  </button>
                  <button 
                    onClick={() => handleRequestQuote(product)}
                    className="flex-1 bg-white text-[#2C2C90] border border-[#2C2C90] py-2 rounded-full hover:bg-[#2C2C90] hover:text-white transition-colors"
                  >
                    Request Quote
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">No products found matching your criteria.</p>
          </div>
        )}
      </div>

      {/* Quote Modal */}
      <RequestQuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        productName={selectedProduct?.name}
      />
    </div>
  );
};

export default Products; 
